import trialLocations from './trial-locations';
export default trialLocations;
